<div class="container-fluid margin-top-custom">
  <div class="title">
    <a [routerLink]="['/settings/banner-positions']"
      >{{ 'label.ManageBanners' | translate }} >
    </a>
    <a
      [routerLink]="['/settings/banner-positions', bannerPositionId, 'banners']"
    >
      {{ bannerPositionName }} >
    </a>
    <div *ngIf="edit; else elseBlock">{{ 'label.Edit' | translate }}</div>
    <ng-template #elseBlock> {{ 'label.AddNew' | translate }} </ng-template>
    <div>( {{ target[targetId] }} )</div>
  </div>

  <p-tabView [activeIndex]="tabIndex">
    <p-tabPanel
      [selected]="edit && bannerModel?.typeId != type.Html"
      [disabled]="edit && bannerModel.typeId == type.Html"
      header="{{ 'label.Image' | translate }}"
    >
      <app-ads-edit
        [type]="type.Image"
        [templateData]="bannerModel"
        [bannerPositionId]="bannerPositionId"
        [targetId]="targetId"
        [isEdit]="edit"
      ></app-ads-edit>
    </p-tabPanel>
    <p-tabPanel
      [selected]="edit && bannerModel?.typeId != type.Image"
      [disabled]="edit && bannerModel.typeId == type.Image"
      header="{{ 'label.Html' | translate }}"
    >
      <app-ads-edit
        [type]="type.Html"
        [templateData]="bannerModel"
        [bannerPositionId]="bannerPositionId"
        [targetId]="targetId"
        [isEdit]="edit"
      ></app-ads-edit>
    </p-tabPanel>
  </p-tabView>
</div>
